import { Helmet } from "react-helmet-async";

interface PageHeadProps {
  title: string;
  description: string;
  path: string;
  type?: "website" | "article";
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
  /** Keep the page out of search indexes (internal tools, utility routes). */
  noindex?: boolean;
}

const SITE = "https://rantfree.in";

export const PageHead = ({
  title,
  description,
  path,
  type = "website",
  image,
  jsonLd,
  noindex = false,
}: PageHeadProps) => {
  const url = `${SITE}${path}`;
  const ogImage =
    image ||
    "https://storage.googleapis.com/gpt-engineer-file-uploads/PQFgJuUXvsPuAQTr0ZQ0cWJne1r2/social-images/social-1767530099292-rantfree-png.png";
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default PageHead;
